import { render, staticRenderFns } from "./CreateBandwidthPolicy.vue?vue&type=template&id=44791189&scoped=true"
import script from "./CreateBandwidthPolicy.vue?vue&type=script&lang=js"
export * from "./CreateBandwidthPolicy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44791189",
  null
  
)

export default component.exports